import React, {Component} from 'react';
import DriversList from './drivers-list';
import OrdersList from './orders-list';
import DispatchList from './dispatch-list';
import logo from '../../assets/images/ic_launcher.png';
import './Sidebar.css';


export default class Sidebar extends Component {


    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-title">
                    <img alt={'PizzaHut'} src={logo} className="sidebar-title-logo"/>
                    <span className="sidebar-title-label">
                        <h1>{this.props.storeName}</h1>
                    </span>
                </div>
                <div className="drivers-lists">
                    <DriversList
                        type="free"
                        onChangeFilter={this.props.onChangeFilter}
                        getStatusFilter={this.props.getStatusFilter}
                        drivers={this.props.drivers.filter(driver => driver.status === 'free')}
                        headerTitle="LIVRES"
                    />
                    <DriversList
                        type="returning"
                        onChangeFilter={this.props.onChangeFilter}
                        getStatusFilter={this.props.getStatusFilter}
                        drivers={this.props.drivers.filter(driver => driver.status === 'returning')}
                        headerTitle="DE REGRESSO"
                    />
                    <DriversList
                        type="busy"
                        onChangeFilter={this.props.onChangeFilter}
                        getStatusFilter={this.props.getStatusFilter}
                        drivers={this.props.drivers.filter(driver => driver.status === 'busy')}
                        headerTitle="OCUPADOS"
                    />
                </div>
                <OrdersList
                    appState={this.props.appState}
                    orders={this.props.orders}
                />
                <DispatchList
                    appState={this.props.appState}
                    data={this.props.scheduled}
                />

            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/Sidebar/index.js